import { memo } from 'react'
import PropTypes from 'prop-types'


const BzHeading = ({ size, ...props }) => {
    switch (size) {
        case 'h1': {
            return (
                <h1 {...props}>
                    {props.children}
                </h1>
            )
        }
        case 'h2': {
            return (
                <h2 {...props}>
                    {props.children}
                </h2>
            )
        }
        case 'h3': {
            return (
                <h3 {...props}>
                    {props.children}
                </h3>
            )
        }
        case 'h4': {
            return (
                <h4 {...props}>
                    {props.children}
                </h4>
            )
        }
        case 'h5': {
            return (
                <h5 {...props}>
                    {props.children}
                </h5>
            )
        }
        case 'h6': {
            return (
                <h6 {...props}>
                    {props.children}
                </h6>
            )
        }
        default: {
            return (
                <h1 {...props}>
                    {props.children}
                </h1>
            )
        }
    }

}

BzHeading.prototype = {
    size: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
}
BzHeading.defaultProps = {
    size: 'h1'
}

export default memo(BzHeading);